import { css } from '@emotion/react';
import { tokens, applyFont } from '@domain-group/fe-brary';
import { AGENCY_AGENT_LAYOUT_MAX_WIDTH } from '../../../constants';

const { colors, spacing, typography } = tokens;

const TWO_LINE_SPLIT_BREAKPOINT = 935;

export const container = css`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  max-width: ${AGENCY_AGENT_LAYOUT_MAX_WIDTH}px;
  margin: 0 auto;
  padding: ${spacing.l} 0 0;
  margin-bottom: ${spacing.m};

  @media (max-width: ${TWO_LINE_SPLIT_BREAKPOINT}px) {
    display: block;

`;

export const heading = css`
  ${applyFont(typography.heading)}
  color: ${colors.neutral.heavy.default};
  line-height: 35px;
`;

export const separator = css`
  margin: 0 ${spacing.xs};
  font-size: 32px;
  color: ${colors.neutral.heavy.default};
  position: relative;
  top: 7px;

  @media (max-width: ${TWO_LINE_SPLIT_BREAKPOINT}px) {
    display: none;
  }
`;

// note: this aligns the stars to the bottom of the title
export const starContainer = css`
  position: relative;
  top: 2px;
`;
